import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';
import { WarrantReferencePayload, WarrantReferenceResponse } from './get-warrant-reference.type';

// createSilobagService
export async function getWarrantReferenceService({ query: rawQuery }: WarrantReferencePayload) {
  const query = transformIntoQueryParamString(rawQuery);
  const { response, data } = await BACKEND.get<WarrantReferenceResponse>(ENDPOINT.WARRANT_COMPANY, { query });

  return {
    response,
    summary: data,
  };
}
